module.exports = __webpack_public_path__ + "static/img/youhuachongdian.5128311.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/youhuachongdian.png
// module id = Hku5
// module chunks = 1